<template>
  <v-row>
    <v-col cols="12">
      <v-alert
        v-if="currPosBlocked"
        dense
        border="left"
        type="warning"
        dismissible
      >
        Chức năng tìm <strong>vị trí hiện tại</strong> đang bị khóa, vui lòng kiểm tra lại!
      </v-alert>
      <GmapMap
        :center="positionObj"
        :zoom="8"
        map-type-id="terrain"
        style="width: 100%; height: 300px"
        ref="mapRef"
        class="mt-2"
      >
        <DirectionsRenderer 
          travelMode="DRIVING" 
          :origin="origin" 
          :destination="destination"
          strokeColor="#00b0ff"
          strokeWeight="5"
        />
        <GmapMarker
          :position="positionObj"
          :clickable="true"
          :draggable="false"
          :animation="2"
        />
      </GmapMap>
    </v-col>
  </v-row>
</template>
<script>
  import DirectionsRenderer from "@/components/public/business/DirectionsRenderer";
  export default {
    props: {
      positionObj: {
        type: Object,
        default: function () {
          return { 
            lat:  10.420288, 
            lng: 106.296844
          }
        }
      },
      businessObj: {
        type: Object
      }
    },
    components: {
      DirectionsRenderer,
    },
    data: () => ({
      origin: {},
      destination: {},
      currMarkerTmp: null,
      destMarkerTmp: null,
      currPosBlocked: false,
      infowindow: null,
      infowindow_curr: null
    }),
    watch: {
      positionObj(){
        this.getRoute();
      },
      businessObj(){
        this.getRoute();
      }
    },
    mounted() {
      this.getRoute();
    },
    methods: {
      getRoute(){
        const app = this;
        navigator.geolocation.getCurrentPosition(function(position) {
          app.origin = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
          if(app.positionObj){
            app.destination = new google.maps.LatLng(app.positionObj.lat, app.positionObj.lng);
            // đặt lại marker cho vị trí đích
            app.destMarkerTmp = new google.maps.Marker({
              position: {
                lat: app.positionObj.lat,
                lng: app.positionObj.lng
              },
              animation: google.maps.Animation.DROP,
              map: app.$refs.mapRef.$mapObject
            });

            let address = "";
            let main_address = `${app.businessObj.dmXa.ten}, 
              ${app.businessObj.dmHuyen.ten}, 
              ${app.businessObj.dmTinh.ten}`;

            if(app.businessObj.duong){
              address = `${app.businessObj.duong}, ${main_address}`;
            } else {
              address = main_address;
            }

            if (app.infowindow) {
              app.infowindow.close();
            }

            app.infowindow = new google.maps.InfoWindow({
              content: app.getInfoWindowContent({
                name: app.businessObj.tenCoSo,
                location: address
              }),
            });
            app.infowindow.open({
              anchor: app.destMarkerTmp,
              map: app.$refs.mapRef.$mapObject,
              shouldFocus: false,
            });
          }
          // đặt lại marker cho vị trí hiện tại
          app.currMarkerTmp = new google.maps.Marker({
            position: {
              lat: position.coords.latitude, 
              lng: position.coords.longitude
            },
            animation: google.maps.Animation.DROP,
            icon: { 
              url: require('@/assets/current_pos.png'), 
              scaledSize: {width: 35, height: 35}
            },
            map: app.$refs.mapRef.$mapObject
          });

          if (app.infowindow_curr) {
            app.infowindow_curr.close();
          }

          app.infowindow_curr = new google.maps.InfoWindow({
            content: app.getInfoWindowContentCurr('Vị trí hiện tại'),
          });
          app.infowindow_curr.open({
            anchor: app.currMarkerTmp,
            map: app.$refs.mapRef.$mapObject,
            shouldFocus: false,
          });
        },
        function(error) {
          if (error.code == error.PERMISSION_DENIED){
            app.currPosBlocked=true;
            app.map = app.positionObj;
          }
        });
      },
      toggleInfoWindow: function (marker, idx) {
        this.infoWindowPos = marker.position;
        this.infoContent = this.getInfoWindowContent(marker);

        //check if its the same marker that was selected if yes toggle
        if (this.currentMidx == idx) {
          this.infoWinOpen = !this.infoWinOpen;
        }
        //if different marker set infowindow to open and reset current marker index
        else {
          this.infoWinOpen = true;
          this.currentMidx = idx;
        }
      },
      getInfoWindowContent: function (marker) {
        return (`<div class="font-weight-bold">${marker.name}</div>`);
      },
      getInfoWindowContentCurr: function (location) {
        return (`<div>${location}</div>`);
      },
    }
  }
</script>